import React from 'react';
import { connect } from 'react-redux';
import {
    putAdministracionTiposPublicacion,
    deleteAdministracionTiposPublicacion,
    postTiposPublicacionAsociarGrupoPlanes
} from '../../api/axios';
import {
    setTiposPublicacion,
    fetchTiposPublicacionAdmById,
    setTiposGrupoPlanes
} from '../../actions/tiposPublicacionActions';
import {
    setId,
    setPlanes,
    setPlanesDesdeBusqueda,
    setDataGrupoCopy,
    setDataGrupo
} from '../../actions/planesActions';
import ModalItem from '../General/Modal';
import { editando } from '../../actions/generalActios';
import { toast } from 'react-toastify';


class TipoPublicacionesEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comision: "",
            descripcion: "",
            cambioInputChange: false,
            comisionPredeterminada: ""
        }
    };

    componentDidMount() {
        this.props.fetchTiposPublicacionAdmById({
            idTipoPublicacion: this.props.setTipoPublicacion.id,
            cantidadPagina: 10,
            numeroPagina: 1
        });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        
        let { id, descripcion, comision } = this.props.setTipoPublicacion;
        let request = {
            idTipoPublicacion: id,
            descripcion: descripcion,
            comision: parseFloat(comision)
        }

        let guardar = putAdministracionTiposPublicacion(request);
        
        guardar.then(res => {
            toast.success("Tipo de publicacion modificada");
            if (this.props.tiposGruposPlanes != undefined) {
                this.asociarGrupoPlanes(this.props.setTipoPublicacion.id);
            }
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("El tipo de publicacion no pudo ser modificado");
        })
    }

    asociarGrupoPlanes = (id) => {
        let elementIdGrupo = null;
        let arrayIdsElement = [];
        for (let index = 0; index < this.props.tiposGruposPlanes.length; index++) {
            elementIdGrupo = this.props.tiposGruposPlanes[index].idGrupoPlan;
            arrayIdsElement.push(elementIdGrupo);
        }
        let data = {
            idTipoPublicacion: id,
            listaIdsGrupoPlanes: arrayIdsElement
        }

        let asociarGrupoPlanes = postTiposPublicacionAsociarGrupoPlanes(data);
        asociarGrupoPlanes.then(res => {
            toast.success("Se asociaron grupos de planes");
        }).catch(err => { });
    }

    onDelete = () => {
        const req = deleteAdministracionTiposPublicacion(this.props.tipoPublicacion.codigo);
        req.then(res => {
            toast.success("Tipo de publicación borrado");
            this.goToTipoPublicaciones();
        }).catch(err => {
            toast.error("No se pudo realizar esta tarea");
        });
    }

    goToBusqueda = () => {

        if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {
            this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
        }

        this.props.editando(true);
        this.props.history.push("/Tipo/Publicaciones/GrupoPlanes/Busqueda");
    }

    goToPlan = (idGrupoPlan) => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setDataGrupoCopy({})
        this.props.setPlanes([]);
        this.props.setId(idGrupoPlan);
        this.props.history.push(`/Planes/Editar/${idGrupoPlan}`);
    }

    goToTipoPublicaciones = () => {
        this.props.history.push("/Tipo/Publicaciones");
    }

    setData_tiposGruposPlanes = () => {
        if (JSON.stringify(this.props.tiposGruposPlanes) == "[]") {
            this.props.setTiposGrupoPlanes(this.props.tipoPublicacion.grupoPlanes);
        }
    }

    borrarFila = (idGrupoPlan) => {
        this.setData_tiposGruposPlanes();
        let grupoPlanes = JSON.stringify(this.props.tiposGruposPlanes);
        if (grupoPlanes != "[]") {
            let index = this.props.tiposGruposPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
            this.props.tiposGruposPlanes.splice(index, 1);
            this.props.setTiposGrupoPlanes(this.props.tiposGruposPlanes);
            this.forceUpdate();
        }
    }

    tablaGrupos = () => {
        let jsonData = JSON.stringify(this.props.tiposGruposPlanes);

        if (jsonData != "[]" && jsonData != undefined) {
            var rows = [];
            let htmlData;
            this.props.tiposGruposPlanes.map((item, index) => {
                htmlData =
                    <tr
                        key={index}
                        className="allow-pointer-cursor hover-background-color text-center"
                        onClick={() => this.goToPlan(item.idGrupoPlan)}
                    >
                        <td>{item.idGrupoPlan}</td>
                        <td>{item.descripcion}</td>
                        <td>
                            <small className="font-14 applyFont">
                                {item.comision}
                                <i className="fas fa-percent mx-1" />
                            </small>
                        </td>
                        <td onClick={(e) => (e.stopPropagation(), this.borrarFila(item.idGrupoPlan))}>
                            <i className="fas fa-trash-alt" />
                        </td>
                    </tr>
                rows.push(htmlData);
            });
            return rows;
        } else {
            if (this.props.tipoPublicacion.grupoPlanes != undefined) {
                var rows = [];
                let htmlData;
                this.props.tipoPublicacion.grupoPlanes.map((item, index) => {
                    htmlData =
                        <tr
                            key={index}
                            className="allow-pointer-cursor hover-background-color text-center"
                            onClick={() => this.goToPlan(item.idGrupoPlan)}
                        >
                            <td>{item.idGrupoPlan}</td>
                            <td>{item.descripcion}</td>
                            <td>
                                <small className="font-14 applyFont">{item.comision}
                                    <i className="fas fa-percent mx-1" />
                                </small>
                            </td>
                            <td onClick={(e) => (e.stopPropagation(), this.borrarFila(item.idGrupoPlan))}>
                                <i className="fas fa-trash-alt" />
                            </td>
                        </tr>
                    rows.push(htmlData);
                });
                return rows;
            }
        }
    }

    inputChange = (e) => {

        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name === "comision") {

            let esNumero = valor.match(numbersOnly);

            if (esNumero == null) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: "" });
                return;
            }

            if (e.target.value >= 100) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: 100 });
            } else {
                this.setState({ cambioInputChange: true, comisionPredeterminada: valor });
                let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor };
                this.props.setTiposPublicacion(estado);
            }
        } else {
            let estado = { ...this.props.setTipoPublicacion, [e.target.name]: valor }
            this.props.setTiposPublicacion(estado);
        }
    }


    render() {

        let descripcion;
        let comision;
        if (this.state.cambioInputChange) {
            comision = this.state.comisionPredeterminada;
        } else {
            descripcion = this.props.setTipoPublicacion.descripcion != undefined ? this.props.setTipoPublicacion.descripcion : this.props.tipoPublicacion.descripcion;
            comision = this.props.setTipoPublicacion.comision != undefined ? this.props.setTipoPublicacion.comision : this.props.tipoPublicacion.comision;
        }

        return (
            <div className="container card">
                <div className="row justify-content-between align-items-center card-body p-4">

                    <div className="col-10 col-md-5">
                        <h4 className="card-title">Tipo de publicaciones</h4>
                    </div>

                    <div className="col-2 col-md-auto button-group">
                        <button
                            type="button"
                            onClick={this.goToBusqueda}
                            className="btn btn-sm background-rojo-megatone"
                        >
                            <i className="fa fa-plus-circle" /> Agregar
                        </button>
                    </div>

                    <form className="col-12 form-horizontal form-material" onSubmit={this.onSubmit}>
                        <div className="form-group">
                            <div className="row justify-content-evenly">

                                <div className="col-10 col-md-7">
                                    <label className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        value={descripcion}
                                        onChange={this.inputChange}
                                        type="text"
                                        id="firstName"
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-2">

                                    <small className="font-14 applyFont">
                                        <i className="fas fa-percent mx-1" />
                                    </small>

                                    <label className="label-oscura">Comisión</label>

                                    <input
                                        name="comision"
                                        value={comision}
                                        onChange={this.inputChange}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>

                            </div>
                        </div>

                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="div-center">ID</th>
                                    <th>Descripción</th>
                                    <th className="div-center">Comisión</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.tablaGrupos()
                            }
                            </tbody>
                        </table>

                        <div className="row justify-content-center">
                            <button
                                onClick={this.onSubmit}
                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el tipo de publicación?"
                                onDelete={this.onDelete}
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                            />

                            <button
                                onClick={this.goToTipoPublicaciones}
                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                            >
                                Cancelar
                            </button>
                        </div>
                        
                    </form>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    editando: state.general.editando,
    tipoUsuario: state.general.tipoUsuario,
    tipoPublicacion: state.tiposPublicacion.tiposPublicacion,
    tiposGruposPlanes: state.tiposPublicacion.tiposGruposPlanes,
    setTipoPublicacion: state.tiposPublicacion.setTiposPublicacion,
    grupoPlanesDesdeBusqueda: state.planes.grupoPlanesBusqueda
});

export default connect(mapStateToProps, {
    fetchTiposPublicacionAdmById,
    setTiposPublicacion,
    setTiposGrupoPlanes,
    editando,
    setId,
    setPlanes,
    setDataGrupo,
    setDataGrupoCopy,
    setPlanesDesdeBusqueda
})(TipoPublicacionesEdit);